const area_train_routes = [
    [
        // 县培训学校微能力申报
        {
            path: "/areatrainabilitydclare",
            name: "areaTrainAbilityDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校微能力申报'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/personal/areaTrain/areaTrainAbilityDclare.vue"
                ),
        },
        // 县培训学校微能力申报详情
        {
            path: "/areaTrainabilitydclaredetail",
            name: "areaTrainAbilityDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校微能力申报'
                },
                {
                    path: '/',
                    name: 'xx学校'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "areaTrainAbilityDclareDetail" */
                    "../../views/personal/areaTrain/areaTrainAbilityDclareDetail.vue"
                ),
        },
        // 县培训学校微能力待认定
        {
            path: "/areatrainawaitconfirm",
            name: "AreaTrainAwaitConfirm",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '教师信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '待认定'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "areaTrainAwaitConfirm" */
                    "../../views/personal/areaTrain/AreaTrainAwaitConfirm.vue"
                ),
        },
        // 县培训学校微能力已认定
        {
            path: "/areatrainhadconfirm",
            name: "AreaTrainHadConfirm",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '教师信息技术应用能力审核认定'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AreaTrainHadConfirm" */
                    "../../views/personal/areaTrain/AreaTrainAwaitConfirm.vue"
                ),
        },
        // 个人测评报告测评报告
        {
            path: '/personagetestnoticearea',
            name: 'areaTrainAbilityDclare',
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校微能力申报'
                },
                {
                    path: '/',
                    name: 'xxx学校'
                },
                {
                    path: '/',
                    name: 'xxx教师微能力测评报告'
                }
                ]
            },
            component: () => import( /* webpackChunkName: "PersonageTestNotice" */
                "../../views/personal/PersonageTestNotice.vue")
        },
        // 校管校本研修与考核方案
        {
            path: "/schoolmngstudyplan",
            name: "areaTrainAbilityDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校微能力申报'
                },
                {
                    path: '/',
                    name: 'xxx学校'
                },
                {
                    path: '/',
                    name: '校本研修与考核方案'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngStudyPlan" */
                    "../../views/personal/schoolMng/SchoolMngDevelopPlan.vue"
                ),
        },
        // 校管学校信息化发展计划
        {
            path: "/schoolmngdevelopplan",
            name: "areaTrainAbilityDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校微能力申报'
                },
                {
                    path: '/',
                    name: 'xxx学校'
                },
                {
                    path: '/',
                    name: '学校信息化发展规划'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngDevelopPlan" */
                    "../../views/personal/schoolMng/SchoolMngDevelopPlan.vue"
                ),
        },
        // 综合测评报告
        {
            path: "/synthesizetestnotice",
            name: "areaTrainAbilityDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校微能力申报'
                },
                {
                    path: '/',
                    name: 'xxx学校'
                },
                {
                    path: '/',
                    name: '教师微能力测评报告(综合)'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SynthesizeTestNotice" */
                    "../../views/personal/SynthesizeTestNotice.vue"
                ),
        },
        // 县培训学校微能力申报
        {
            path: "/areaEvaluation",
            name: "areaEvaluation",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评比'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/personal/areaTrain/areaEvaluation.vue"
                ),
        },
        // 县培训学校微能力申报
        {
            path: "/areaEvaluationDeil",
            name: "areaEvaluationDeil",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评比'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/personal/areaTrain/areaEvaluationDeil.vue"
                ),
        },
        // 市培训学校微能力申报
        {
            path: "/ciytEvaluation",
            name: "ciytEvaluation",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评比'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/personal/areaTrain/ciytEvaluation.vue"
                ),
        },
        // 市培训学校微能力申报
        {
            path: "/ciytAreaList",
            name: "ciytAreaList",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评比'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/personal/areaTrain/ciytAreaList.vue"
                ),
        },
        // 市培训学校微能力申报
        {
            path: "/cityEvaluationDeil",
            name: "cityEvaluationDeil",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评比'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolTrainTest" */
                    "../../views/personal/areaTrain/cityEvaluationDeil.vue"
                ),
        },

    ],
    [
        // 县培训学校微能力认定详情
        {
            path: "/areatraitinyconfirm",
            name: "AreaTrainAwaitConfirm",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '教师能力审核认定'
                },
                {
                    path: '/',
                    name: '详情'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "areaTrainAwaitConfirm" */
                    "../../views/personal/areaTrain/areaTrainTinyConfirm.vue"
                ),
        },
        // 微能力教师成果认定详情  
        {
            path: '/abilityconfirmdetail',
            name: 'AbilityConfirmDetail',
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                }
                ]
            },
            component: () => import( /* webpackChunkName: "AbilityConfirmDetail" */ '../../views/personal/tearch/ability/AbilityConfirmDetail.vue'),
        },
        // 非微能力教师成果详情
        {
            path: "/noabilityachievementxq",
            name: "NoAbilityAchievementRd",
            meta: ["信息技术应用能力认定", "成果认定", "成果详情"],
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NoAbilityAchievementRd" */
                    "../../views/personal/tearch/no_ability/NoAbilityAchievementXq.vue"
                ),
        },

    ]

];

export default area_train_routes;